import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { CreateMaterialModel } from '../products/types'
import {
  CreateMaterialPayload,
  MaterialsType,
  UpdateMaterialPayload,
} from '~/entities/materials/model/types'
import { ApiResponse } from '~/shared/lib/types/api'

export class MaterialsService {
  static getMaterials(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<MaterialsType[]>> {
    return apiService.get<AxiosResponse<MaterialsType[]>>('/materials', config)
  }

  static getMaterialById(id: string): Promise<AxiosResponse<MaterialsType>> {
    return apiService.get<AxiosResponse<MaterialsType>>(`/materials/${id}`)
  }

  static addMaterial(
    data: CreateMaterialModel,
  ): Promise<AxiosResponse<MaterialsType>> {
    return apiService.post<AxiosResponse<MaterialsType>>('/materials', data)
  }

  static updateMaterial(
    id: string,
    data: UpdateMaterialPayload,
  ): Promise<AxiosResponse<MaterialsType>> {
    return apiService.put<AxiosResponse<MaterialsType>>(`materials/${id}`, data)
  }

  static createMaterial(
    data: CreateMaterialPayload,
  ): Promise<AxiosResponse<MaterialsType>> {
    return apiService.post<AxiosResponse<MaterialsType>>('/materials', data)
  }

  static deleteMaterial(id: string): Promise<AxiosResponse<ApiResponse>> {
    return apiService.delete<AxiosResponse<ApiResponse>>(`materials/${id}`)
  }
}
